import type { PaymentMethod } from "features/paymentMethods/types";

export const stripForDuplicate = (paymentMethod: PaymentMethod): PaymentMethod => {
    const { coreId: _coreId, name: _name, PSP: _PSP, ...rest } = paymentMethod;

    return {
        ...rest,
        name: '',
        PSP: ''
    } as PaymentMethod;
};
